import React from 'react';
import { Container, Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import logo from '../../../assets/images/Logo.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
const ClientRegistration = () => {
	const [validated, setValidated] = useState(false);
	const [selectedPlanId, setSelectedPlanId] = useState(null);
	const [clientData, setClientData] = useState(null);
	const [getPlan, setGetPlan] = useState(null);
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const handleTermsClick = () => {
		navigate('/termsOfServices');
	};
	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(
					'https://api.getcogen.com/api/getClientPlans',
					{
						headers: { Accept: 'application/json' },
					}
				);
				setGetPlan(response?.data?.client_plans);
				console.log('Data retrieved successfully:', response?.data?.plans);
			} catch (error) {
				toast.error(error.response?.data?.message);
				console.error('Error fetching data:', error.message);
			}
		};

		fetchData();
	}, []);

	const handleSubmit = async event => {
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		} else {
			event.preventDefault();

			const formData = new FormData(form);
			const email = form[2].value;
			const cEmail = form[3].value;

			if (email !== cEmail) {
				setError('Email and confirm email must be same');
				return;
			}

			formData.append('plan_id', selectedPlanId);
			console.log(Object.fromEntries(formData), 'testing data');

			try {
				const token = `Bearer ${localStorage.getItem('token')}`;
				const response = await axios.post(
					'https://api.getcogen.com/api/clientRegisteration',
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
							Accept: 'application/json',
							Authorization: token,
						},
					}
				);

				localStorage.setItem('token', response?.data?.token);
				setClientData(response?.data?.data);
				console.log(clientData, 'abcdefgh');
				toast.success(response?.data?.message);
				if (response.data.success === true) {
					navigate('/verificationModal', {
						state: { email: formData.get('email') },
					});
				}
				console.log(response?.data?.data, 'worldhelo');
			} catch (error) {
				toast.error(error.response?.data?.message);
				console.error('Error submitting form:', error);
			}
		}

		setValidated(true);
	};
	const handleHomeClick = () => {
		navigate('/');
	};

	// css
	// const containerStyle = {
	// 	display: 'flex',
	// 	height: '680px',
	// };

	// const verticalLineStyle = {
	// 	borderRight: '1px solid #dbd9d9',

	// };
	const containerStyle = {
		fontSize: '19px',
		fontFamily: 'Calibri, sans-serif',
	};

	const pricingListStyle = {
		listStyleType: 'decimal',
		marginLeft: '0.5in',
	};

	const nestedListStyle = {
		listStyleType: 'upper-alpha',
		marginLeft: '1em',
	};

	const subNestedListStyle = {
		listStyleType: 'lower-roman',
		marginLeft: '2em',
	};
	const Basic = getPlan?.[0]?.plan_name;
	const Premium = getPlan?.[1]?.plan_name;
	return (
		<Container>
			<Row className='py-5 mt-1 align-items-center'>
				<Col md={5}>
					<img
						src={logo}
						onClick={handleHomeClick}
						alt='logo'
						style={{
							height: '10vmin',
							marginLeft: '105px',
							marginBottom: '30px',
							cursor: 'pointer',
						}}
					/>
					<h1>Welcome to Cogen</h1>
					<p className='font-italic text-muted mb-0'>
						Choose between our {Basic} and {Premium} plans, each offering unique
						benefits. Find the perfect plan tailored to your needs and elevate
						your experience with Cogen.
					</p>
					<div style={containerStyle}>
						<ol style={pricingListStyle}>
							<ol style={nestedListStyle}>
								{getPlan?.map(plan => (
									<li>
										<div
											className='form-check'
											style={{ marginTop: '10px' }}
											key={plan.id}
										>
											<input
												className='form-check-input'
												type='radio'
												name='plan_id'
												id={`flexRadioDefault${plan.id}`}
												value={plan.id.toString()} // Convert the id to a string as it is used as the value
												onChange={e => setSelectedPlanId(e.target.value)}
												required
											/>
											<label
												className='form-check-label'
												style={{ fontWeight: 'bold' }}
											>
												{plan.plan_name} Program (${plan.total})
											</label>{' '}
											<br />
											<label className='form-check-label font-italic text-muted mb-0'>
												Initial Startup Fee is ${plan.annual_fee}. This includes
												the Initial Setup Fee and 1 year Maintenance and Tech
												Support .
											</label>
											<label className='form-check-label font-italic text-muted mb-0'>
												Every year after the 1st year will be{' '}
												{plan.mentanance_fee} for just the Maintenance and Tech
												Support Fee.
											</label>
											{plan.plan_name === 'Basic' && (
												<>
													<label className='form-check-label font-italic text-muted mb-0'>
														Up to 48-hour response by
													</label>
													<ol style={subNestedListStyle}>
														<ol style={{ listStyleType: 'decimal' }}>
															<li>Email submission</li>
															<li>Chat submission</li>
															<li>Website submission</li>
														</ol>
													</ol>
												</>
											)}
											{plan.plan_name === 'Premium' && (
												<>
													<label className='form-check-label font-italic text-muted mb-0'>
														Same Day up to Next Day Service
													</label>
													<ol style={subNestedListStyle}>
														<ol style={{ listStyleType: 'decimal' }}>
															<li>Telephone</li>
															<li>Chat</li>
														</ol>
													</ol>
												</>
											)}
										</div>
									</li>
								))}
							</ol>
						</ol>
					</div>
				</Col>

				<Col sm={6}>
					<Form noValidate validated={validated} onSubmit={handleSubmit}>
						<Row className='mb-2'>
							<Form.Group as={Col} md='6' controlId='validationCustom01'>
								<Form.Label>First name</Form.Label>
								<Form.Control
									required
									type='text'
									placeholder='First name'
									name='first_name'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter a first name.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label>Last name</Form.Label>
								<Form.Control
									required
									type='text'
									name='last_name'
									placeholder='Last name'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter a last name.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustomUsername'>
								<Form.Label>Email</Form.Label>
								<InputGroup hasValidation>
									<InputGroup.Text id='inputGroupPrepend'>@</InputGroup.Text>
									<Form.Control
										type='email'
										placeholder='Email'
										name='email'
										aria-describedby='inputGroupPrepend'
										required
									/>
									<Form.Control.Feedback type='invalid'>
										Please choose a email.
									</Form.Control.Feedback>
								</InputGroup>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustomUsername'>
								<Form.Label>Confirm Email</Form.Label>
								<InputGroup hasValidation>
									<InputGroup.Text id='inputGroupPrepend'>@</InputGroup.Text>
									<Form.Control
										type='email'
										placeholder='Confirm Email'
										name='confirmEmail'
										aria-describedby='inputGroupPrepend'
										required
									/>

									<Form.Control.Feedback type='invalid'>
										Please choose a email.
									</Form.Control.Feedback>
								</InputGroup>
								{error && (
									<Form.Text className='d-block text-danger'>{error}</Form.Text>
								)}
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustomUsername'>
								<Form.Label>Contact number</Form.Label>
								<InputGroup hasValidation>
									<Form.Control
										type='text'
										placeholder='Contact number'
										name='phone'
										aria-describedby='inputGroupPrepend'
										required
									/>
									<Form.Control.Feedback type='invalid'>
										Please enter a contact number.
									</Form.Control.Feedback>
								</InputGroup>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom01'>
								<Form.Label>Company name</Form.Label>
								<Form.Control
									required
									type='text'
									name='company_name'
									placeholder='Company name'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter company name
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='12' controlId='validationCustom01'>
								<Form.Label>Company head quarters address</Form.Label>
								<Form.Control
									required
									type='text'
									name='address'
									placeholder='Company address'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter company Address
								</Form.Control.Feedback>
							</Form.Group>
							{/* <Form.Group
								as={Col}
								md='6'
								className='text-truncate'
								controlId='validationCustom02'
							>
								<Form.Label>
									Business license / Company registration #
								</Form.Label>
								<Form.Control
									required
									type='text'
									name='company_registration_no'
									placeholder='Business license / Company registration number'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter Business license or company registration number
								</Form.Control.Feedback>
							</Form.Group> */}
						</Row>
						<Row>
							<Form.Group as={Col} md='6' controlId='validationCustom03'>
								<Form.Label>City</Form.Label>
								<Form.Control
									type='text'
									name='city'
									placeholder='City'
									required
								/>
								<Form.Control.Feedback type='invalid'>
									Please provide a city.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='3' controlId='validationCustom04'>
								<Form.Label>State</Form.Label>
								<Form.Control
									type='text'
									name='state'
									placeholder='State'
									required
								/>
								<Form.Control.Feedback type='invalid'>
									Please provide a state.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='3' controlId='validationCustom05'>
								<Form.Label>Zip</Form.Label>
								<Form.Control
									type='text'
									name='zip'
									placeholder='Zip'
									required
								/>
								<Form.Control.Feedback type='invalid'>
									Please provide a zip.
								</Form.Control.Feedback>
							</Form.Group>
						</Row>
						<Row>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label> Password </Form.Label>
								<Form.Control
									required
									type='password'
									name='password'
									placeholder='Password '
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter Password{' '}
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label>Confirm password </Form.Label>
								<Form.Control
									required
									type='password'
									name='confirm_password'
									placeholder='Confirm password '
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter Confirm password{' '}
								</Form.Control.Feedback>
							</Form.Group>
						</Row>

						<Row>
							<Form.Group className='mb-3 mt-3 d-flex align-items-center'>
								<Form.Check
									required
									// label='Agree to terms and conditions'
									feedback='You must agree before submitting.'
									feedbackType='invalid'
								//
								/>
								<span
									onClick={handleShow}
									style={{ cursor: 'pointer', marginLeft: '8px' }}
								>
									Agree to terms and conditions
								</span>
							</Form.Group>
						</Row>
						<Button type='submit'>Create your account</Button>
					</Form>
					<div className='form-group col-lg-12 ' style={{ marginTop: '15px' }}>
						<p className='text-muted fw-bold'>
							Already Registered? <a href='/'>Login</a>
						</p>
					</div>
				</Col>
			</Row>
			<>
				<Modal
					show={show}
					onHide={handleClose}
					backdrop='static'
					keyboard={false}
				>
					<Modal.Header closeButton>
						<Modal.Title>NOTE</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						Please save all your data before leaving this page to prevent any
						loss. Your progress is important to us!
					</Modal.Body>
					<Modal.Footer>
						<Button variant='secondary' onClick={handleClose}>
							Close
						</Button>
						<Button variant='primary' onClick={handleTermsClick}>
							Understood
						</Button>
					</Modal.Footer>
				</Modal>
			</>
		</Container>
	);
};

export default ClientRegistration;
